import { render, staticRenderFns } from "./DataManager.vue?vue&type=template&id=34daf56f"
import script from "./DataManager.vue?vue&type=script&lang=js"
export * from "./DataManager.vue?vue&type=script&lang=js"
import style0 from "./DataManager.vue?vue&type=style&index=0&id=34daf56f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports